module.exports = __webpack_public_path__ + "img/mini-018.25f6cf67.jpg";